import styled from 'styled-components'

export const Link = styled.a`
    margin-bottom: 3rem;
    @media print {
        display: none;
    };
    display: flex;
    align-items: center;
`